import { gql } from '@apollo/client'

export default gql(`
    mutation deleteProductionStudio($id: ID!, $name: String, $project: String) {
        deleteProductionStudio(
                id: $id,
                name: $name,
                project: $project
        ) {
            id
            name
            assetCount
        }
    }`
)
